import { Button } from '@mui/material'
import React, { ComponentPropsWithRef } from 'react'
import { useTranslation } from '../i18n/useTranslation'
import { useCommonCtx } from '../context/useCommonCtx'
import { OCODES, OCODES_TYPE, SUBCODES } from '../services/types'
import { MTypo } from '../components/MTypo/MTypo'
import { apiService } from '../services/apiServices'

interface Props extends ComponentPropsWithRef<'div'> {
    onClick: () => void
    onQuit?: () => void // FIXME cf. Thanks.tsx
    disabled: boolean
    error: [OCODES_TYPE, SUBCODES]
}
export const Error = (p: Props) => {
    const { error = ['UNKNOWN', 'ERROR'], disabled = false } = p
    const [code, subcode] = error
    console.log({ code, subcode })
    const commons = useCommonCtx()
    const t = useTranslation(commons)
    const isDupEntry =
        code === OCODES.BAD_REQUEST.key && subcode === 'ER_DUP_ENTRY'
    const isValidationError =
        code === OCODES.BAD_REQUEST.key && subcode === 'VALIDATION'

    let errorMsg = ''
    if (isValidationError) {
        errorMsg = t('hint_error_validation')
    } else if (isDupEntry) {
        errorMsg = t('hint_error_dup')
    } else {
        errorMsg = t('hint_error')
    }

    let errorBtn = ''
    if (isDupEntry) {
        errorBtn = t('btn_download')
    } else {
        errorBtn = t('retry_btn')
    }

    return (
        // FIXME to be aligned with Thanks.tsx (justif-evenly)
        <div className="flex flex-1 flex-col justify-center items-center">
            <MTypo variant="h4" className="text-center">
                {errorMsg}
            </MTypo>
            {!disabled && (
                <>
                    <br />
                    <br />
                    <Button variant="outlined" onClick={p.onClick}>
                        <MTypo variant="h5" className="text-center">
                            {errorBtn}
                        </MTypo>
                    </Button>
                </>
            )}
            {/* FIXME shall we add this? */}
            {/* <Button
                variant="outlined"
                onClick={() => apiService.logout('/login')}
            >
                <MTypo variant="h5" className="text-center">
                    {t('btn_quit')}
                </MTypo>
            </Button> */}
        </div>
    )
}
